import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; // Use named import

const ProtectedRoute = ({ children, staffOnly }) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user')
  if (!token && !user) {
    return <Navigate to="/login" replace />;
  }

  try {
    const decoded = jwtDecode(token); // Use jwtDecode (named export)
    const currentTime = Date.now() / 1000; // Current time in seconds
    
    // Check if token is expired
    if (decoded.exp < currentTime) {
      localStorage.removeItem('token');
      return <Navigate to="/login" replace />;
    }

    // Check for staff-only routes
    if (staffOnly && decoded.role !== 'Support') {
      return <Navigate to="/home" replace />;
    }

    return children;
  } catch (error) {
    console.error('Invalid token:', error);
    localStorage.removeItem('token');
    return <Navigate to="/login" replace />;
  }
};

export default ProtectedRoute;